export default __webpack_public_path__ + "static/media/message-circle-white.7f86437d.svg";